import { useAtomValue } from "jotai";
import {
  DefaultNodeData,
  tableUsageAtomFamily_SUSPENDS,
  tablesUsageAtom_SUSPENDS,
} from "@zapier/canvas-state";
import RecordProgress from "./RecordProgress";

interface TableUsageProps {
  tableId: DefaultNodeData["tableId"];
}

export function TableUsage({ tableId }: TableUsageProps) {
  const tableUsage = useAtomValue(tableUsageAtomFamily_SUSPENDS(tableId));
  const tablesUsage = useAtomValue(tablesUsageAtom_SUSPENDS);

  if (!tableUsage || !tablesUsage) {
    return null;
  }

  const { recordCount } = tableUsage;

  return (
    <RecordProgress
      numberOfRecords={recordCount}
      limit={tablesUsage.maxRecordsCount}
    />
  );
}
